import React, { Component } from 'react';
import config from 'react-global-configuration';

import Select from 'react-select';
import Toggle from 'react-toggle';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../../i18n/getLocale';

class ProcessSubtypeEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      documents_list: [],
      document_ids: [],
      required: 0,
      id: this.props.process_subtype_id,
      process_id: this.props.process_id,
      subtype_data: this.props.subtype_data,
      process_subtype_documents: this.props.subtype_data.process_subtype_documents,
    };

    this.deleteSubtype = this.deleteSubtype.bind(this);
    this.addDocument = this.addDocument.bind(this);
    this.deleteDocument = this.deleteDocument.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);

    this.locale = getLocale();
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    this.setState({
      id: newProps.process_subtype_id,
      process_id: newProps.process_id,
      subtype_data: newProps.subtype_data,
      process_subtype_documents: newProps.subtype_data.documents,
      documents_list: newProps.documents_list,
    });
  }

  addDocument(event) {
    event.preventDefault();
    var datasave = {
      document_ids: this.state.document_ids,
      process_subtype_id: this.state.id,
      process_id: this.state.process_id,
      required: this.state.required,
    };
    var self = this;
    var header = self.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/processo/subtipo/documentos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.refreshSubtypes(responseJson);
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteDocument (event) {
    var process_subtype_document_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Processos.EditarProcesso.tabDadosDoProcesso.deletarDocumento);
    if (confirm) {
      var self = this;
      self.props.handleAlert('', '', 'open');
      var header = self.props.RequestApi.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/processo/subtipo/documento/' + process_subtype_document_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.refreshSubtypes(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deleteSubtype (event) {
    var confirm = window.confirm(this.locale.Processos.EditarProcesso.tabDadosDoProcesso.deletarSubtipoEDocumentosRelacionados);
    if (confirm) {
      var self = this;
      self.props.handleAlert('', '', 'open');
      var header = self.props.RequestApi.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/processo/subtipo/' + self.state.id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.refreshSubtypes(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  ActionsButtons (cell, row) {    
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.deleteDocument}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }
  
  render() {
    return (
<div>
  <h3 >{this.state.subtype_data['name']} - {this.locale.Processos.EditarProcesso.tabDadosDoProcesso.tituloDocumentos} <button className="btn btn-sm btn-danger" value={this.state.subtype_data['id']} onClick={this.deleteSubtype}><i className="fa fa-fw fa-trash"></i></button></h3>
  <div className="clearfix"></div>
  <form onSubmit={this.addDocument}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Processos.EditarProcesso.tabDadosDoProcesso.formularioDocumentos.Documentos}:</label>
          <Select
            className="form-field-name"
            name="document_ids"
            value={this.state.document_ids}
            searchable={true}
            multi={true}
            placeholder={this.locale.Processos.EditarProcesso.tabDadosDoProcesso.formularioDocumentos.placeholder.SelecionarDocumentos}
            onChange={this.handleSelectChange.bind(this, 'document_ids')}
            options={this.state.documents_list}
          />    
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Processos.EditarProcesso.tabDadosDoProcesso.formularioDocumentos.DocumentObrigatorio}?</label>
          <br/>
          <Toggle
            checked={this.state.required}
            aria-label='No label tag'
            name="required"
            onChange={this.handleToggleChange.bind(this, 'required')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-plus"></i> {this.locale.Processos.EditarProcesso.tabDadosDoProcesso.formularioDocumentos.botaoAdicionarDocumento}</button>
      </div>
    </div>
  </form>
  <hr/>
  <BootstrapTable data={this.state.process_subtype_documents} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Processos.EditarProcesso.tabDadosDoProcesso.tabelaDocumentos.semDocumentos}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Processos.EditarProcesso.tabDadosDoProcesso.tabelaDocumentos.ID}</TableHeaderColumn>

    <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Processos.EditarProcesso.tabDadosDoProcesso.tabelaDocumentos.Documento}</TableHeaderColumn>

    <TableHeaderColumn dataField="required_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Processos.EditarProcesso.tabDadosDoProcesso.tabelaDocumentos.DocumentoObrigatorio}?</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.Processos.EditarProcesso.tabDadosDoProcesso.tabelaDocumentos.Acoes}</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default ProcessSubtypeEdit;



// WEBPACK FOOTER //
// ./src/Components/Processes/Elements/ProcessSubtypeEdit.js